import { createSelector } from 'reselect';
import ReceptacleMonitoringResponsePerformanceColumns
  from '../../containers/ReceptacleMonitoringResponsePerformanceColumns';
import ReportsDefinition from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.RECEPTACLE_MONITORING_RESPONSE_PERFORMANCE
    .metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RECEPTACLE_MONITORING_RESPONSE_PERFORMANCE.isLoading;

export const getData = ReportsDefinition.RECEPTACLE_MONITORING_RESPONSE_PERFORMANCE
  .getDataFunction();

export const getColumns =
  createSelector(getData, ReceptacleMonitoringResponsePerformanceColumns);
